import { AbstractParser } from "../../parser";
import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { parseBeneficiary } from "./beneficiary-parse-functions";

export class FindBeneficiaryByKeyParser extends AbstractParser<Beneficiary> {
  parse(payload: any): Beneficiary {
    return parseBeneficiary(payload);
  }
}
